module.exports = "<app-spinner text=\"Generating report, please wait...\"></app-spinner>"


//////////////////
// WEBPACK FOOTER
// ./src/app/report/components/save/report-save.component.html
// module id = ./src/app/report/components/save/report-save.component.html
// module chunks = main